import {
  getOwnerMemoGetQueryKey,
  getOwnerMemoListQueryKey,
  ownerMemoCreate,
  ownerMemoDelete,
  ownerMemoGet,
  ownerMemoList,
  ownerMemoUpdate,
  useOwnerMemoCreate,
  useOwnerMemoDelete,
  useOwnerMemoGet,
  useOwnerMemoGetSuspense,
  useOwnerMemoList,
  useOwnerMemoListSuspense,
  useOwnerMemoUpdate,
} from "@/api/generated/endpoints/api"
import { ownerMemoCreateBody, ownerMemoUpdateBody } from "@/api/generated/schemas/api.zod"

export * as OwnerMemoModels from "./models"
export * from "./models"

export const ownerMemoApi = {
  // Query Hooks
  useOwnerMemoList,
  useOwnerMemoListSuspense,
  useOwnerMemoGet,
  useOwnerMemoGetSuspense,

  // Query Keys
  getOwnerMemoListQueryKey,
  getOwnerMemoGetQueryKey,

  // Raw API functions
  ownerMemoList,
  ownerMemoGet,
  ownerMemoCreate,
  ownerMemoUpdate,
  ownerMemoDelete,

  // Mutation Hooks
  useOwnerMemoCreate,
  useOwnerMemoUpdate,
  useOwnerMemoDelete,
}

export const ownerMemoSchemas = {
  ownerMemoCreateBody,
  ownerMemoUpdateBody,
}
